import $ from "jquery"; 

class Rate {
    //1. describe and initiate object
    constructor(){
        this.openRankButton=$(".js-rank-trigger");
        this.closeRankButton=$(".js-rank-close-trigger");
        this.closeDailyRankButton=$(".js-rank-close-trigger-daily");
        this.submitRankButton=$(".js-rank-submit-trigger");
        this.patchRankButton=$(".js-rank-patch-trigger");
        this.patchRankButtonTemp=$(".js-rank-patch-trigger-temp");
        this.currentRanking=$("#js-my-current-rating");
        this.currentCounts=$("#js-my-current-counts");
        this.userRating=$("#js-current-user-rating");
        this.rankModal=$('#rankModal-random');
        this.rankModalDaily=$('#rankModal');
        this.loading=$('#loading-wrapper');
        this.dailyid=$(".js-daily-album-id");
        this.loaded=$(window)
        //initialize events
        this.events();
    }

    //2. list all events
    events(){
        this.openRankButton.on("click",this.openRank.bind(this));
        this.closeRankButton.on("click",this.closeRank.bind(this));
        this.closeDailyRankButton.on("click",this.closeDailyRank.bind(this));
        this.submitRankButton.on("click",this.submitRank.bind(this));
        this.patchRankButton.on("click",this.patchRank.bind(this));
        this.patchRankButtonTemp.on("click",this.patchRankTemp.bind(this));
        this.loaded.on("load",this.openDailyRank.bind(this));
        
    }
    //3. Methods or functions 
    openRank(){
        let total = document.querySelectorAll('.random-modals').length-1;
        let randomNumberOld = localStorage.getItem("random-number");
        let randomNumbers =[];
        this.rankModal.removeClass("display-none");
        
        if(randomNumberOld){
            $('#random-'+randomNumberOld+'').addClass("display-none");
            $('#another-button-'+randomNumbers[i-1]+'').addClass("display-none");
            $('#coffee-button-'+randomNumbers[i-1]+'').addClass("display-none");
        }
        for(var i=0;i<10;i++){
            randomNumbers.push(Math.floor(Math.random() * (total - 0 + 1)) + 0);   
        }
        localStorage.setItem("random-number", randomNumbers[randomNumbers.length-1]);
        for(var i =0;i<randomNumbers.length;i++){
            if(i==0){
                $('#random-'+randomNumbers[i]+'').removeClass("display-none");
                
            }else{
                (function(index) {
                    setTimeout(function() { 
                        console.log(i)
                        $('#random-'+randomNumbers[index-1]+'').addClass("display-none");
                        $('#random-'+randomNumbers[index]+'').removeClass("display-none");
                        if(index==9){
                            $('#another-button-'+randomNumbers[index]+'').removeClass("display-none");
                            $('#coffee-button-'+randomNumbers[index]+'').removeClass("display-none");
                        }   
    
                    }, i * 250);
                })(i);

            }
        }
    }
    openDailyRank(){

        if(this.dailyid[0]!==undefined){
            let album=parseInt(this.dailyid[0].dataset.albumid);
            let daily = localStorage.getItem('dailyAlbum'); 
            if((!daily || daily!=album) && this.dailyid[0].dataset.dailyfound==true){
                localStorage.setItem('dailyAlbum',album); 
                this.rankModalDaily.removeClass("display-none");
            }

        }

    }
    closeRank(){
        let randomNumber = localStorage.getItem("random-number");
        $('#random-'+randomNumber+'').addClass("display-none");
        this.rankModal.addClass("display-none");
    }
    closeDailyRank(){
        this.rankModalDaily.addClass("display-none");
    }
    patchRank(){
        let ranks=document.getElementsByName('rating2');
        let rank=0;
        ranks.forEach(e => {
            if(e.checked==true){
                rank=e.value;
            }
        });
        if(rank>0 && rank<=10){
            this.patchRankButton.addClass("display-none");
            this.loading.removeClass("display-none");
            this.currentRanking[0].innerHTML=rank;
            this.rankModal.addClass("display-none");
            let data={
                'user_id':parseInt(this.patchRankButton[0].dataset.user),
                'id': parseInt(this.patchRankButton[0].dataset.id),
                'rating': rank,
                'post_id': parseInt(this.patchRankButton[0].dataset.postid),
                'type':this.patchRankButton[0].dataset.type
            };
            let url=recordreviverData.root_url+'/wp-json/recordreviver/v1/rate';

            $.ajax({
                beforeSend: (xhr)=>{
                    xhr.setRequestHeader('X-WP-Nonce',recordreviverData.nonce);
                },
                url:url,
                type: 'PATCH',
                data:data,
                success: (response)=>{
                    if(this.patchRankButton[0].dataset.daily==false){
                        this.userRating[0].innerHTML=response[1].toFixed(3);
                        this.patchRankButton.removeClass("display-none");
                        this.loading.addClass("display-none");
                    }
                    
                
                },
                error: (response)=>{
                    console.log(response);
                }
            });
        }
        
    }
    submitRank(){
        let ranks=document.getElementsByName('rating2');
        let rank=0;
        ranks.forEach(e => {
            if(e.checked==true){
                rank=e.value;
            }
        });
        if(rank>0 && rank<=10){
            if(this.submitRankButton[0].dataset.daily==false){
                this.currentCounts[0].innerHTML= (parseInt(this.currentCounts[0].innerHTML)+1).toString() + " Ratings";
                this.currentRanking[0].innerHTML=rank;
            }
            this.submitRankButton.addClass("display-none");
            this.loading.removeClass("display-none");
            this.rankModal.addClass("display-none");
            let data={
                'user_id':parseInt(this.submitRankButton[0].dataset.user),
                'id': parseInt(this.submitRankButton[0].dataset.id),
                'rating': rank,
                'type':this.submitRankButton[0].dataset.type
            };
            let url=recordreviverData.root_url+'/wp-json/recordreviver/v1/rate';

            $.ajax({
                beforeSend: (xhr)=>{
                    xhr.setRequestHeader('X-WP-Nonce',recordreviverData.nonce);
                },
                url: url,
                type: 'POST',
                data: data,
                success: (response)=>{
                    if(this.submitRankButton[0].dataset.daily==false){
                        this.loading.addClass("display-none");
                        this.currentRanking[0].innerHTML=rank;
                        this.userRating[0].innerHTML=response[1].toFixed(3);
                        this.patchRankButtonTemp[0].dataset.postid=response;
                        this.submitRankButton.addClass("display-none");
                        this.patchRankButtonTemp.removeClass("display-none");
                    }

                },
                error: (response)=>{
                    console.log(response);
                }
            });
        }
        
        //this.rankModal.addClass("display-none");
    }
    patchRankTemp(){
        let ranks=document.getElementsByName('rating2');
        let rank=0;
        ranks.forEach(e => {
            if(e.checked==true){
                rank=e.value;
            }
        });
        if(rank>0 && rank<=10){
            this.patchRankButtonTemp.addClass("display-none");
            this.loading.removeClass("display-none");
            this.currentRanking[0].innerHTML=rank;
            this.rankModal.addClass("display-none");
            let data={
                'user_id':parseInt(this.patchRankButtonTemp[0].dataset.user),
                'id': parseInt(this.patchRankButtonTemp[0].dataset.id),
                'rating': rank,
                'post_id': parseInt(this.patchRankButtonTemp[0].dataset.postid),
                'type':this.patchRankButtonTemp[0].dataset.type
            };
            let url=recordreviverData.root_url+'/wp-json/recordreviver/v1/rate';

            $.ajax({
                beforeSend: (xhr)=>{
                    xhr.setRequestHeader('X-WP-Nonce',recordreviverData.nonce);
                },
                url: url,
                type: 'PATCH',
                data:data,
                success: (response)=>{
                    this.patchRankButtonTemp.removeClass("display-none");
                    this.loading.addClass("display-none");
                    
                    this.userRating[0].innerHTML=response[1].toFixed(3);
                    
                },
                error: (response)=>{
                    console.log(response);
                }
            });
        }
        
    }
}
    
export default Rate;